import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToasterService } from 'angular2-toaster';
import { WebServiceService } from '../../shared/services/web-service.service';
import { CompanySetupService } from '../../shared/services/company-setup.service';

@Component({
  selector: 'app-generic-approvals',
  templateUrl: './generic-approvals.component.html',
  styleUrls: ['./generic-approvals.component.scss'],
  providers:[CompanySetupService,WebServiceService]

})
export class GenericApprovalsComponent implements OnInit {
  @Input() approvalDetails: any;
  commonVariableList: any = { "approvals": [] }
  @Output()
  sendAction = new EventEmitter()
  constructor(private toasterService: ToasterService, private webService: WebServiceService,public comanySetup:CompanySetupService) { }
  company_setup: any = {};
  stillLoading:boolean=false;
  setup:any={}
  hideApproval:any='0';

  ngOnInit() {
    this.setup=this.approvalDetails.setup?this.approvalDetails.setup:{}
    this.setup.is_setup=this.approvalDetails.is_setup?this.approvalDetails.is_setup:false;
    if(this.setup.is_setup)
    {
      this.setSetupData(this.setup);
    }
    else
    {
    this.GetCompanySetUpData();
    }

  }
  GetCompanySetUpData() {
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '')
{
  return false;
}
    let req:any={}
    this.company_setup={}
      this.stillLoading=true;
    this.webService.commonPostMethod("Update_company_meta/ajax_getall_bycompany", req).subscribe(
      data => {
        if (data.status)

        {
          this.setSetupData(data.response);
        }
      this.stillLoading=false;
      }, error => {
        this.stillLoading=false;
      }
    )
  }
  setSetupData(data)
  {
    this.company_setup={}
    this.stillLoading=true;
    this.company_setup=data ? data : {}

    this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '';
    if (this.company_setup.product_catalog_id != undefined && this.company_setup.product_catalog_id != '') {
      this.company_setup.product_catalog_id = '1'
    }
    // this.company_setup.product_catalog_id = this.company_setup.product_catalog_id ? this.company_setup.product_catalog_id : '0';

this.company_setup.pr_approval_date_format = this.company_setup.pr_approval_date_format ? this.company_setup.pr_approval_date_format : 'date';
this.company_setup.enable_multiple_parallel_approver_in_setapproval_limitV2 = this.company_setup.enable_multiple_parallel_approver_in_setapproval_limitV2 ? this.company_setup.enable_multiple_parallel_approver_in_setapproval_limitV2 : '0';
this.company_setup.enable_parallel_approver_in_po_module = this.company_setup.enable_parallel_approver_in_po_module ? this.company_setup.enable_parallel_approver_in_po_module : '0';
this.company_setup.in_invoice_date_format = this.company_setup.in_invoice_date_format ? this.company_setup.in_invoice_date_format : "dd-mm-yyyy";


this.company_setup.enable_parallel_approver_in_normal_invoice_module = this.company_setup.enable_parallel_approver_in_normal_invoice_module ? this.company_setup.enable_parallel_approver_in_normal_invoice_module : '0';
this.company_setup.enable_parallel_approver_in_invoice_payment_module = this.company_setup.enable_parallel_approver_in_invoice_payment_module ? this.company_setup.enable_parallel_approver_in_invoice_payment_module : '0';
this.company_setup.enable_parallel_approver_in_dc_note_module = this.company_setup.enable_parallel_approver_in_dc_note_module ? this.company_setup.enable_parallel_approver_in_dc_note_module : '0';
this.company_setup.enable_parallel_approver_in_pr_module = this.company_setup.enable_parallel_approver_in_pr_module ? this.company_setup.enable_parallel_approver_in_pr_module : '0';
this.company_setup.hold_info_visible_in_po_hyperlink = this.company_setup.hold_info_visible_in_po_hyperlink ? this.company_setup.hold_info_visible_in_po_hyperlink :'0';


switch (this.approvalDetails.id) {
case 'prreport':
  if (this.company_setup.enable_parallel_approver_in_pr_module && this.company_setup.enable_parallel_approver_in_pr_module == '1') {
    this.showDefault();
  }else{
    this.showPr();
  }
  // this.showPr();
  break;

  case 'irreport':
    this.showIr();
    break;
  case 'rfqNumberReport':
    this.showRfqData();
    break;
  case 'rfqResponseReport':
    this.showRfqData();
    break;
default: this.showDefault();
}
this.stillLoading=false;
}
  showPr() {
    if (this.approvalDetails.id) {
      this.commonVariableList.approvals = [];
      let approval;
      this.commonVariableList.approvals = this.approvalDetails.data.approvals ? this.approvalDetails.data.approvals : []
        for(let i=0; i<this.commonVariableList.approvals.length; i++){
          if(this.commonVariableList.approvals[i].approval_status == '2') {
            approval = i+1;
            break;
          }
        }
        for(let j=approval; j<this.commonVariableList.approvals.length; j++){
          this.commonVariableList.approvals[j].approval_status = '3';
          this.commonVariableList.approvals[j].date_updated = ''
        }
      if (this.company_setup.pr_approval_date_format == 'date_and_time') {
        return;
      }
      if (this.commonVariableList.approvals) {
        for (let i of this.commonVariableList.approvals) {
            i.date_added = new Date(i.date_added) ?  new Date(i.date_added) : ''
          i.date_updated =  new Date(i.date_updated) ?  new Date(i.date_updated) : ''
          i.is_approver_updated = i.is_approver_updated ? i.is_approver_updated : '0';
        }
      }
    }
  }
  showIr() {
    if (this.approvalDetails.id) {
      this.commonVariableList.approvals = [];
      let approval;
      this.commonVariableList.approvals = this.approvalDetails.data.approvals ? this.approvalDetails.data.approvals : []
        for(let i=0; i<this.commonVariableList.approvals.length; i++){
          if(this.commonVariableList.approvals[i].approval_status == '2') {
            approval = i+1;
            break;
          }
        }
        for(let j=approval; j<this.commonVariableList.approvals.length; j++){
          this.commonVariableList.approvals[j].approval_status = '3';
        }
      if (this.company_setup.ir_approval_date_format == 'date_and_time') {
        return;
      }
      if (this.commonVariableList.approvals) {
        for (let i of this.commonVariableList.approvals) {

          i.date_added = this.webService.formatDate(i.date_added, 'yy-mm-dd', '-') ? this.webService.formatDate(i.date_added, 'yy-mm-dd', '-') : ''
          i.date_updated = this.webService.formatDate(i.date_updated, 'yy-mm-dd', '-') ? this.webService.formatDate(i.date_updated, 'yy-mm-dd', '-') : ''

        }
      }
    }
  }
  showAppType : boolean = false;
  showDefault() {
    if (this.approvalDetails.id) {
      this.commonVariableList.approvals = [];
      let approval;
      this.commonVariableList.approvals = this.approvalDetails.data.approvals ? this.approvalDetails.data.approvals : []
      this.hideApproval = this.approvalDetails.data.hideApproval ? this.approvalDetails.data.hideApproval : '0';
      this.approvalDetails.data.is_direct= this.approvalDetails.data.is_direct? this.approvalDetails.data.is_direct:'0';

        for(let i=0; i<this.commonVariableList.approvals.length; i++){
          if(this.commonVariableList.approvals[i].approval_status == '2') {
            approval = i+1;
            break;
          }
        }    
        // for(let j=approval; j<this.commonVariableList.approvals.length; j++){
        //   this.commonVariableList.approvals[j].approval_status = '3';
        //   this.commonVariableList.approvals[j].date_updated = ''
        // }
        if(this.approvalDetails.id=="invoicereport" || this.approvalDetails.id=="poreport" || this.approvalDetails.id=="dcnotereport") {
          for(let i=0; i<this.commonVariableList.approvals.length; i++) {
            if(this.commonVariableList.approvals[i].approval_type!='Single' && this.commonVariableList.approvals[i].approval_type!='') {
              this.showAppType = true;
            }
          }
        }

        if((this.approvalDetails.final_approval_status == '0') && (this.approvalDetails.has_multi_approval == '1')) {
          let pendingAppLevel = '';
          let pendingAppType = '';
          for(let i=0; i<this.commonVariableList.approvals.length; i++){
            if(this.commonVariableList.approvals[i].final_approval_status=='0') {
              pendingAppLevel = this.commonVariableList.approvals[i].employee_level;
              pendingAppType = this.commonVariableList.approvals[i].approval_type;
              break;
            }
          }

          let pendingAppLevelInt = this.webService.convertNaN(pendingAppLevel)

          if(pendingAppType!='' && pendingAppLevel!='') {
            if(pendingAppType=='Anyone') {
              for(let i=0; i<this.commonVariableList.approvals.length; i++){
                let tmpPendingAppLevelInt = this.webService.convertNaN(this.commonVariableList.approvals[i].employee_level)
                if(pendingAppLevelInt > tmpPendingAppLevelInt) {
                  this.commonVariableList.approvals[i].approval_status = this.commonVariableList.approvals[i].approval_status=='0' && this.commonVariableList.approvals[i].approval_status=='0' ? '3' : this.commonVariableList.approvals[i].approval_status;
                }
              }
            } else if(pendingAppType=='Multiple') {
              
              let pendingAppLevelInt = this.webService.convertNaN(pendingAppLevel)
              for(let i=0; i<this.commonVariableList.approvals.length; i++){
                let tmpPendingAppLevelInt = this.webService.convertNaN(this.commonVariableList.approvals[i].employee_level)
                if(pendingAppLevelInt > tmpPendingAppLevelInt) {
                  this.commonVariableList.approvals[i].approval_status = this.commonVariableList.approvals[i].approval_status=='0' ? '3' : this.commonVariableList.approvals[i].approval_status;
                }
              }
            } else {
              for(let i=0; i<this.commonVariableList.approvals.length; i++){
                let tmpPendingAppLevelInt = this.webService.convertNaN(this.commonVariableList.approvals[i].employee_level)
                if(pendingAppLevelInt > tmpPendingAppLevelInt) {
                  this.commonVariableList.approvals[i].approval_status = this.commonVariableList.approvals[i].approval_status=='0' && this.commonVariableList.approvals[i].approval_status=='0' ? '3' : this.commonVariableList.approvals[i].approval_status;
                }
              }
            }
          }
        } else {
          for(let j=approval; j<this.commonVariableList.approvals.length; j++){
            this.commonVariableList.approvals[j].approval_status = this.commonVariableList.approvals[j].approval_status=='0' ? '3' : this.commonVariableList.approvals[j].approval_status;
          }
        }
                

      if (this.commonVariableList.approvals) {
        let c = 1;
        for (let i of this.commonVariableList.approvals) {
          // i.date_added = this.webService.formatDate(i.date_added, 'yy-mm-dd', '-') ? this.webService.formatDate(i.date_added, 'yy-mm-dd', '-') : ''
          // i.date_updated = this.webService.formatDate(i.date_updated, 'yy-mm-dd', '-') ? this.webService.formatDate(i.date_updated, 'yy-mm-dd', '-') : ''
          i.employee_level = i.employee_level ? i.employee_level : c;
          c++;

          if(i.approval_status=='3') {
            i.date_updated = '';
          }
        }
      }
    }
  }
  showRfqData() {
    if (this.approvalDetails.id) {
      this.commonVariableList.approvals = [];
      let approval;
      console.log("this.approvalDetails.data", this.approvalDetails.data)
      this.commonVariableList.approvals = this.approvalDetails.data.rfq_approvals ? this.approvalDetails.data.rfq_approvals : []
      for(let i=0; i<this.commonVariableList.approvals.length; i++){
        if(this.commonVariableList.approvals[i].approval_status == '2') {
          approval = i+1;
          break;
        }
      }
      for(let j=approval; j<this.commonVariableList.approvals.length; j++){
        this.commonVariableList.approvals[j].approval_status = '3';
      }
      if (this.commonVariableList.approvals) {
        for (let i of this.commonVariableList.approvals) {
          i.source_name=i.source_name?i.source_name:''

          i.date_added = this.webService.formatDate(i.date_added, 'yy-mm-dd', '-') ? this.webService.formatDate(i.date_added, 'yy-mm-dd', '-') : ''
          i.date_updated = this.webService.formatDate(i.date_updated, 'yy-mm-dd', '-') ? this.webService.formatDate(i.date_updated, 'yy-mm-dd', '-') : ''

        }
      }
    }
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1885384336/src/src/app/generic-ui-components/generic-approvals/generic-approvals.component.ts